var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MobileSimpleModalContainer",
    [
      _c("v-flex", { class: _vm.$style.modalAdvantages }, [
        _c("p", [_vm._v("No Gimmicks, No Frills, No Nonsense")]),
        _vm._v(" "),
        _c("h6", [_vm._v("Grassfed. Natural. Goodness.")])
      ]),
      _vm._v(" "),
      _c("v-flex", [
        _c("h4", { class: _vm.$style.modalTitle }, [
          _vm._v("BURGER BOSS BASICS")
        ])
      ]),
      _vm._v(" "),
      _c("v-flex", { class: _vm.$style.modalIconsInfo }, [
        _c("div", [
          _c("img", {
            attrs: {
              src: require("@/assets/img/glutenfree@2x.jpg"),
              alt: "Gluten Free"
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Gluten Free")])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", {
            attrs: { src: require("@/assets/img/vegan@2x.jpg"), alt: "Vegan" }
          }),
          _vm._v(" "),
          _c("span", [_vm._v("Vegan")])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/HelpModal.vue?vue&type=template&id=6befbdec&
// module id = null
// module chunks = 